export default __webpack_public_path__ + "static/endless256-d979e356535b9c5c64a71f85fd22124f.png";